import {AbstractControl, NG_VALIDATORS, Validator, ValidatorFn} from '@angular/forms';
import {Directive, forwardRef, Host, Inject, OnDestroy, OnInit} from '@angular/core';
import {RevenueDistributionExceptionComponent} from './revenue-distribution.exception.component';
import {DictionaryObject} from '../../../../../common/api';
import {ExceptionTypeService} from '../exception-type.service';

@Directive({
    selector: '[ngModelGroup][tflValidExceptionSettings]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: ExceptionSettingsConflictValidatorDirective,
        multi: true
    }]
})
export class ExceptionSettingsConflictValidatorDirective implements Validator {

    constructor(@Host() @Inject(forwardRef(() => RevenueDistributionExceptionComponent)) private _host: RevenueDistributionExceptionComponent, private _exceptionTypeService: ExceptionTypeService,) {
    }

    validate(control: AbstractControl): { [key: string]: any } {

        let mapLength = (items: DictionaryObject[]) => items ? items.length : 0;

        let total = this._exceptionTypeService.getAvailableConditionsTotal(this._host.exceptionType);
        let selected = mapLength(this._host.selectedConditions);

        let left = mapLength(this._host.availableConditions);

        return this.settingsConflictValidator(total,
            selected,
            left)(control);
    }

    settingsConflictValidator(total: number, selected: number, left: number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            if ((selected + left) === 0) {
                return {
                    settingsConflict: true
                }
            }
            if (selected === total) {
                return {
                    allConditionsSelected: true
                }
            }
            return null;
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/exceptions/exception-settings-conflict-validator.directive.ts